import { INotesComponent } from '@modeso/types__aumico-lib-annualreport-be';
import { ComponentType } from '@modeso/types__aumico-lib-notes-be';

export interface AumicoClipboardData {
    aumicoClipboard: true;
    version: string;
    timestamp: string; // ISO 8601
    componentType: ComponentType;
    component: INotesComponent;
}
